import {GenericBotIcon, HammerBotIcon, IsaBotIcon, SegmentBotIcon} from "@/components/ui/icons"
import {BotHammer, BotSegment, BrandMango, ENABLED_BRANDS} from "@/constants"
import {useBotConfig} from "@/hooks/useBotConfig"

export const useTheme = () => {
    const {cfg} = useBotConfig()
    let BotIcon = <IsaBotIcon />
    let theme = "theme-isa"

    function brandIsEnabled(nameToCheck: string): boolean {
        if (ENABLED_BRANDS && ENABLED_BRANDS.length > 0) {
            const brands = ENABLED_BRANDS.split(",").map((name) => name.trim())
            return brands.includes(nameToCheck)
        }
        return false
    }

    if (cfg.bot === BotHammer) {
        theme = "root"
        BotIcon = <HammerBotIcon />
    } else if (cfg.brand && brandIsEnabled(cfg.brand)) {
        switch (cfg.brand) {
            case BrandMango:
                theme = "theme-brand-mango"
                BotIcon = <GenericBotIcon />

                break
        }
    } else if (cfg.bot === BotSegment) {
        BotIcon = <SegmentBotIcon />
        theme = "theme-segment"
    }

    return {theme, BotIcon}
}
